const PENDING_LOCALE_KEY = "pendingLocale";

const SUPPORTED_LOCALES = ["pt-BR", "en-US", "es-ES", "zh-CN"];

const isSupported = (value: string | null): value is string =>
  value !== null && SUPPORTED_LOCALES.includes(value);

export const savePendingLocale = (code: string): void => {
  if (!isSupported(code)) {
    return;
  }

  try {
    localStorage.setItem(PENDING_LOCALE_KEY, code);
  } catch {
    return;
  }
};

export const getPendingLocale = (): string | null => {
  try {
    const stored = localStorage.getItem(PENDING_LOCALE_KEY);
    return isSupported(stored) ? stored : null;
  } catch {
    return null;
  }
};

export const clearPendingLocale = (): void => {
  try {
    localStorage.removeItem(PENDING_LOCALE_KEY);
  } catch {
    return;
  }
};
